import { SettingsConstant } from "./../constants/settings.constants";
import { Injectable } from "@angular/core";
import { environment } from "./../../../environments/environment";
import * as moment from "moment";
@Injectable({
  providedIn: "root"
})
export class GenericUtils {
  isMobile() {
    if (window.innerWidth < 769) {
      return true;
    } else {
      return false;
    }
    //SettingsConstant.TABLE_CARD_WIDTH_START)
  }

  cleanParameters(obj) {
    for (const propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === "" ||
        obj[propName] === "All" ||
        obj[propName] === "ALL"
      ) {
        delete obj[propName];
      } else {
        obj[propName] = typeof obj[propName] === "string" ? obj[propName].trim() : obj[propName];
      }

    }
    return obj;
  }

  getCookie(name) {
    const cookieName = name + "=",
      ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(cookieName) === 0) {
        const cookieValue = c.substring(cookieName.length, c.length);
        try {
          if (JSON.parse(cookieValue)) {
            return JSON.parse(cookieValue);
          }
        } catch (e) {
          return cookieValue;
        }
      }
    }
    return null;
  }

  getSubDomainName() {
    const parts = location.hostname.split(".");
    const subdomain = parts.shift();
    if (!parts.length) {
      return "localhost";
    } else if (subdomain === "127") {
      return "127.0.0.1";
    } else {
      return parts.join(".");
    }
  }

  storeCookie(name, value, expiry, domain) {
    let expires = "";
    let cookieValue = "";
    if (expiry) {
      expires = "expires=" + expiry;
    } else {
      const d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      expires = "expires=" + d.toUTCString();
    }
    if (typeof value === "object") {
      cookieValue = JSON.stringify(value);
    } else {
      cookieValue = value;
    }
    document.cookie =
      name + "=" + cookieValue + ";path=" + ";domain=" + domain + ";" + expires;
  }

  getParamsObjectFromHash() {
    const hash = window.location.hash ? window.location.hash.split("#") : [];
    let toBeReturned = {};
    if (hash.length && hash[1].split("&").length) {
      toBeReturned = hash[1].split("&").reduce((acc, x) => {
        const hello = x.split("=");
        if (hello.length === 2) acc[hello[0]] = hello[1];
        return acc;
      }, {});
    }
    return Object.keys(toBeReturned).length ? toBeReturned : null;
  }

  storeCookieUtil(tokens) {
    try {
      this.storeCookie(
        SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN,
        tokens.token,
        "",
        this.getSubDomainName()
      );
    } catch (err) { }
  }

  amountIndianUnit(value) {
    let val: any = Math.abs(value);

    if (val >= 1000 && val < 100000) {
      val = (val / 1000).toFixed(2) + " K";
    } else if (val > 100000 && val < 10000000) {
      val = (val / 100000).toFixed(2) + " Lac";
    } else if (val > 10000000) {
      val = (val / 10000000).toFixed(2) + " Cr";
    }
    else {
      val = val.toString().split(".")[1] ? val.toFixed(2) : val
    }
    return val;
  }

  deepCopyFunction(inObject) {
    let outObject, value, key

    if (typeof inObject !== "object" || inObject === null) {
      return inObject // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {}

    for (key in inObject) {
      value = inObject[key]

      // Recursively (deep) copy for nested objects, including arrays
      outObject[key] = (typeof value === "object" && value !== null) ? this.deepCopyFunction(value) : value
    }

    return outObject
  }
  
  cleanNullKeys(data) {
		Object.keys(data).map(key => {
			if (!data[key]) {
				delete data[key];
			} else if (typeof (data[key]) === 'string') {
				data[key] = data[key].trim();
			} else if (typeof (data[key]) === 'object' || Array.isArray(data[key])) {
				Object.keys(data[key]).map(key1 => {
					if (!data[key][key1]) {
						delete data[key][key1];
					} else if (typeof (data[key][key1]) === 'string') {
						data[key][key1] = data[key][key1].trim();
					}
				});
			}
		});
		return data;
  }
  
  amountIndianUnitRoundOff(value) {
    let val: any = Math.abs(value);

    if (val >= 1000 && val < 100000) {
      val = (val / 1000).toFixed(0) + " K";
    } else if (val > 100000 && val < 10000000) {
      val = (val / 100000).toFixed(0) + " Lac";
    } else if (val > 10000000) {
      val = (val / 10000000).toFixed(0) + " Cr";
    }
    else {
      val = val.toString().split(".")[1] ? val.toFixed(0) : val
    }
    return val;
  }

  convertDateToUTC(date){
    return moment(date, 'YYYY-MM-DD HH:m:s').utc().format('YYYY-MM-DD HH:m:s');
  }

}
